<template>
  <div class="posts-search">
    <div class="posts-search__form">
      <div class="filters-container">
        <p class="label">Filters:</p>
        <ul class="filter">
          <li>
            <div class="select-container">
              <select
                id="companies"
                name="companies"
                data-size="5"
                class="select-filter"
                v-model="this.selectedCompanies"
                @change="filterPostsbyClient()"
              >
                <option value="0">All Companies</option>
                <option
                  v-for="company in companies"
                  :key="company.id"
                  :value="company.id"
                >
                  {{ company.name }}
                </option>
              </select>
            </div>
          </li>
        </ul>

        <ul class="filter">
          <li>
            <div class="select-container">
              <select
                aria-label="Year"
                id="years"
                name="years"
                data-size="5"
                class="select-filter"
                v-model="this.selectedYears"
                @change="filterPostsbyYear()"
              >
                <option value="0">All Years</option>
                <option v-for="year in years" :key="year" :value="year">
                  {{ year }}
                </option>
              </select>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div v-if="total == 0 && !loading" class="posts-search__no-results">
      Sorry, there are no news articles that match the above criteria.
    </div>

    <TransitionGroup
      name="stagged-fade"
      tag="div"
      class="posts-search__results"
    >
      <template v-for="(post, index) in posts" :key="index">
        <div class="posts-search__post">
          <div class="news-item-container">
            <a :href="post.customFields.link">
              <div class="image-container">
                <img
                  :src="post.customFields.featured_image_src"
                  :srcset="post.customFields.featured_image_srcset"
                  sizes="(max-width: 480px) 100vw, 50vw"
                  :alt="post.customFields.featured_image_alt"
                  loading="lazy"
                />
              </div>
            </a>

            <div class="content-container">
              <a :href="post.customFields.link">
                <h3 class="card-title" v-html="post.title"></h3
              ></a>
              <p class="date">{{ post.customFields.formatted_date }}</p>
            </div>
          </div>
        </div>
      </template>
    </TransitionGroup>

    <div v-if="loading" class="posts-search__loading-spinner"></div>

    <div v-if="!loading && showMore" class="posts-search__load-more">
      <div @click="getMorePosts" class="button">Load more</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    config: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  components: {},
  data() {
    return {
      posts: [],
      companies: [],
      years: [],
      params: {
        page: 1,
        per_page: 12,
        orderby: "date",
        order: "desc",
        companies: 0,
        years: 0,
      },
      keywords: "",
      selectedYears: "0",
      selectedCompanies: "0",
      loading: false,
      total: 10,
      totalPages: 0,
      staggerDelay: 50,
      paginationType: "loadMore",
      keywordSearch: false,
    };
  },
  mounted() {
    // console.log("hereX");
    this.getCompanies();
    this.getYears();
    this.getPosts();

    if (this.selectedYear !== 0) {
      this.params.year = this.selectedYear;
    } else {
      delete this.params.year;
    }
  },
  computed: {
    showMore() {
      return this.params.page < this.totalPages || this.loading;
    },
    showing() {
      return (
        "<span>" +
        ((this.params.page - 1) * this.params.per_page +
          1 +
          "</span> to <span>" +
          ((this.params.page - 1) * this.params.per_page +
            this.params.per_page) +
          "</span> of <span>" +
          this.total +
          "</span> results")
      );
    },
  },
  methods: {
    isNumeric: function (n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    },
    async getCompanies() {
      this.loading = true;

      await this.axios
        .get("post_clients", {
          params: { per_page: 100 },
        })
        .then((response) => {
          this.companies = response.data;
        });

      this.loading = false;
    },
    async getYears() {
      this.loading = true;

      await this.axios
        .get("news_years", {
          params: { per_page: 100 },
        })
        .then((response) => {
          this.years = response.data;
        });

      this.loading = false;
    },

    async getPosts() {
      this.loading = true;

      const params = { ...this.params };

      if (this.selectedYears !== "0" && this.selectedYears !== 0) {
        params.portfolio_sectors = this.selectedYears;
      } else {
        delete params.portfolio_sectors;
      }

      if (this.selectedCompanies !== "0" && this.selectedCompanies !== 0) {
        params.portfolio_investments = this.selectedCompanies;
      } else {
        delete params.portfolio_investments;
      }

      await this.axios
        .get("posts", {
          params,
        })
        .then((response) => {
          const posts = [];

          response.data.forEach((post) => {
            posts.push({
              link: post.link,
              title: post.title.rendered,
              excerpt: post.excerpt.rendered,
              date: post.formatted_date,
              customFields: post.custom_fields,
            });
          });
          this.posts = this.posts.concat(posts);
          this.total = parseInt(response.headers["x-wp-total"], 10);
          this.totalPages = parseInt(response.headers["x-wp-totalpages"], 10);
        });

      this.loading = false;
    },
    async getMorePosts() {
      this.params.page += 1;
      this.loading = true;

      const params = { ...this.params };

      if (this.selectedYears !== "0" && this.selectedYears !== 0) {
        params.portfolio_sectors = this.selectedYears;
      } else {
        delete params.portfolio_sectors;
      }

      if (this.selectedCompanies !== "0" && this.selectedCompanies !== 0) {
        params.portfolio_investments = this.selectedCompanies;
      } else {
        delete params.portfolio_investments;
      }

      await this.axios
        .get("posts", {
          params,
        })
        .then((response) => {
          const morePosts = [];

          response.data.forEach((post) => {
            morePosts.push({
              link: post.link,
              title: post.title.rendered,
              excerpt: post.excerpt.rendered,
              date: post.formatted_date,
              customFields: post.custom_fields,
            });
          });
          this.posts = this.posts.concat(morePosts);
        });

      this.loading = false;
    },
    filterPosts() {
      this.posts = [];
      this.params.page = 1;
      this.getPosts();
    },
    filterPostsbyYear() {
      this.posts = [];
      this.params.page = 1;

      if (this.selectedYears !== 0 && this.selectedYears !== "0") {
        this.params.year = this.selectedYears;
      } else {
        delete this.params.year;
      }

      this.getPosts();
    },
    filterPostsbyClient() {
      this.posts = [];
      this.params.page = 1;

      if (this.selectedCompanies !== 0 && this.selectedCompanies !== "0") {
        this.params.post_clients = this.selectedCompanies;
      } else {
        delete this.params.post_clients;
      }

      this.getPosts();
    },
    beforeEnter(el) {
      el.style.opacity = 0;
    },
    onEnter(el) {
      const delay = el.dataset.index * this.staggerDelay;
      setTimeout(() => {
        el.style.opacity = 1;
      }, delay);
    },
    onLeave(el) {
      el.style.display = "none";
    },
    paginationCallback(pageNumber) {
      this.params.page = pageNumber;
      // history.pushState(
      //   this.params.page,
      //   'null',
      //   window.location.pathname + '?pl=' + this.params.page,
      // );

      // // Jump to search results.
      // let top = document.getElementById('results-top').offsetTop;
      // window.scrollTo(0, top - 300);

      this.filterPaginationPosts();
    },
  },
};
</script>
